import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Preserve bookmarks and training selections from the former Formations page.
export default function Formations() {
  const location = useLocation();
  const hash = location.hash === '#choix-formations' ? '#formulaire-devis' : location.hash;
  return <Navigate replace to={`/talents-rh/academy${location.search}${hash}`} state={location.state} />;
}
